import InputItemList from '@shared/components/core/field/list/TextInputList';
import { useTranslation } from 'react-i18next';

export interface IDeviceTypeSupportsLocalesEditorProps {
    value: string[];
    onUpdate: (field: 'supportsLocales', value: string[]) => void;
}

export default function DeviceTypeSupportsLocalesEditor({ value, onUpdate }: IDeviceTypeSupportsLocalesEditorProps) {
    const { t } = useTranslation();

    return (
        <InputItemList
            initialValues={value}
            legend={t('common:organization.projects.deviceType.locale.title')}
            description={t('common:organization.projects.deviceType.locale.warn')}
            onChange={(updatedDevices) => onUpdate('supportsLocales', updatedDevices)}
        />
    );
}
